import { render } from "./ReturnsAndRefunds.vue?vue&type=template&id=5a875cb0&scoped=true"
import script from "./ReturnsAndRefunds.vue?vue&type=script&lang=js"
export * from "./ReturnsAndRefunds.vue?vue&type=script&lang=js"

import "./ReturnsAndRefunds.vue?vue&type=style&index=0&id=5a875cb0&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a875cb0"]])

export default __exports__